export default __webpack_public_path__ + "static/media/rocket_anim_122.2204522f.png";